import Cascade from 'components/cascade';

const CascadePage = () => {
  return <Cascade />;
};

export default CascadePage;
